import {
  PlusCircleIcon,
  ArrowLeftCircleIcon,
  ExclamationCircleIcon,
  CheckCircleIcon,
} from "@heroicons/react/24/solid";

const Button2 = ({
  buttonText = "",
  onClick,
  className = "",
  disabled = false,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      type="button"
      className={
        (disabled ? "cursor-not-allowed border  opacity-50 " : "opacity-100") +
        (buttonText === "Recall" || buttonText === "Deny"
          ? `${className} flex items-center place-content-center hover:scale-90 transition duration-500 bg-tranparent  border-blue-500 shadow-md hover:bg-blue-500 text-blue-500 group relative py-1 px-3 border text-xs font-medium rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 focus:ring-opacity-70`
          : `${className} flex items-center place-content-center hover:scale-90 transition duration-500 bg-tranparent  border-senary shadow-md hover:bg-senary text-senary group relative py-1 px-3 border text-xs font-medium rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 focus:ring-opacity-70`)
        //`${className} flex items-center place-content-center hover:scale-90 transition duration-500 bg-tranparent  border-blue-500 shadow-md hover:bg-blue-500 text-blue-500 group relative py-1 px-3 border text-xs font-medium rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 focus:ring-opacity-70`
      }
    >
      {buttonText === "Recall" && (
        <ArrowLeftCircleIcon className="h-4 w-4 mr-2" />
      )}
      {buttonText === "Deny" && (
        <ExclamationCircleIcon className="h-4 w-4 mr-2" />
      )}
      {(buttonText === "Approve" ||
        buttonText === "Open as PDF" ||
        buttonText === "Loading...") && (
        <CheckCircleIcon className="h-4 w-4 mr-2" />
      )}
      <p className="font-semibold"> {buttonText}</p>
    </button>
  );
};
export default Button2;
